/* global showSuccessToast */
/* global showInfoToast */
/* global showWarningToast */
/* global showDangerToast */
import React, { useState, useEffect, use } from "react";
import FooterBar from "./layout/FooterBar";
import globals from '../config/globals.json'
import Calendar from "./tools/Calendar";
import FooterButton from "./tools/FooterButton";

import { getVideos } from "../api/api";

const Academy = (props) => {
    const [loading, setLoading] = useState(false); // <-- aggiungi stato loading
    const companyID = props.userDetails?.Company?.[0]?.dataID || null;

    const [videos, setVideos] = useState([]);

    const fetchVideos = async () => {
        const response = await getVideos(companyID);
        setVideos(response?.data?.data?.getVideoListing?.edges || []);
    };

    useEffect(() => {
        setLoading(true); // mostra loader
        if (companyID) {
            fetchVideos();
            setLoading(false); // nascondi loader
        }
    }, [companyID]);

    return (
        <div className="container-fluid">
            {loading ? (
                <div className="text-center my-4">
                    <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            ) : (
                <React.Fragment>
                    <div className="row clearfix justify-content-center mb-10">
                        {/* <div className="col-xl-6 col-12">
                            <div className="card proj-t-card">
                                <div className="card-body">
                                    <div className="d-flex justify-content-center mt-2 row">

                                    </div>
                                </div>
                            </div>
                        </div> */}
                    </div>
                    <div className="row clearfix justify-content-center mb-10">
                        {videos.length === 0 ? (
                            <div className="col-12 text-center">
                                <p className="text-muted">Nessun video disponibile al momento.</p>
                            </div>
                        ) : (
                            videos.map((video, index) => (
                                <div key={index} className="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-3">
                                    <div className="card">
                                        <div className="card-body">
                                            <a href={video.node.link} target="_blank" rel="noopener noreferrer">
                                                <img src={`https://img.youtube.com/vi/${video.node.link.split("/")[3]}/maxresdefault.jpg`} className="w-100" alt={video.node.title} />
                                            </a>
                                            <hr />
                                            <h6 className="mt-2 mb-0">{video.node.title.toUpperCase()}</h6>
                                            <small>{new Date(video.node.date).toLocaleDateString('it-IT')}</small>
                                        </div>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </React.Fragment>
            )}

            <FooterBar
                footerIcon={"school"}
                footerTitle={"Academy"}
                footerButton={
                    <FooterButton icon="add" title="Aggiungi video" action={() => showInfoToast("Disponibile nel prossimo aggiornamento")} />
                }
            />
        </div>
    );
};
export default Academy;